import { Param } from '../Model/Param';
export class ParamsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(paramId) {
        if (paramId) {
            const response = await this.apiService.get('param/' + paramId);
            if (!response.ok) {
                throw new Error(`Error al obtener el parámetro.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ParamId.`);
        }
    }
    async findByType(type) {
        if (type) {
            const response = await this.apiService.get('params/' + type);
            if (!response.ok) {
                throw new Error(`Error al obtener los parametros.`);
            }
            const content = await response.json();
            return content.map(param => new Param(param).getState());
        }
        else {
            throw new Error(`Error al obtener type.`);
        }
    }
    async findDiferentTypes() {
        const response = await this.apiService.get('diferent_types');
        if (!response.ok) {
            throw new Error(`Error al obtener los parametros.`);
        }
        return await response.json();
    }
    async saveParam(param) {
        if (param) {
            const response = await this.apiService.post('param', param);
            if (!response.ok) {
                throw new Error(`Error al guardar el parametro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener param.`);
        }
    }
    async removeParam(param) {
        if (param) {
            const response = await this.apiService.post('param/remove', param);
            if (!response.ok) {
                throw new Error(`Error al eliminar el parametro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener param.`);
        }
    }
}
